module.exports = __webpack_public_path__ + "static/media/view4.586e8c92.jpg";